export const en = {
  Login: "Login",
  Logout: "Log out",
  Translation: "Nederlands",
  Home: "Home",
  Link: "Link",
  Welcome: "Welcome",
  Username: "Username",
  Password: "Password",
  Send: "Send",
  Documentation: "Documentation",
  "Footer content": "Footer content",
  "Login with DigiD": "Login with DigiD",
  "Login with your account": "Login with your account",
  "Oops, something went wrong": "Oops, something went wrong",
  "Left scroll button": "Left scroll button",
  "Right scroll button": "Right scroll button",
};
